class UtilService {
  getRank(token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/utils/ranks`, {
        method: 'GET',
        headers: {  
          'token': token
        }
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  getSecretLevel(token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/utils/secretLevels`, {
        method: 'GET',
        headers: {  
          'token': token
        }
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }
}

export default UtilService;